import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { FC } from 'react';
import PropTypes from 'prop-types';
import { FilterOption } from 'src/types/filter';

export interface DropDownProps {
  label: string;
  index: string;
  options: Array<FilterOption>;
  selectedOption: string;
  onSelect: (event: any) => void;
}

export const DropDown : FC<DropDownProps> = (props) => {
  const { label: boxLabel, index, options, selectedOption, onSelect } = props;
  //   const handleChange = (event) => {
  //     setAge(event.target.value);
  //   };

  return (
    <FormControl
      size="small"
      sx={{ m: 1, width: '100%' }}
    >
      <InputLabel>{boxLabel}</InputLabel>
      <Select
        value={selectedOption || ''}
        label={boxLabel}
        name={index}
        onChange={onSelect}
      >
        <MenuItem
          key="none"
          value={undefined}
        >
          <em>None</em>
        </MenuItem>
        {options?.map((opt) => (
          <MenuItem
            key={opt.id}
            value={opt.value}
          >
            {opt.value}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

DropDown.propTypes = {
  label: PropTypes.string,
  index: PropTypes.string,
  options: PropTypes.array,
  selectedOption: PropTypes.string,
  onSelect: PropTypes.func,
};
